import DatePicker from 'components/DatePicker';
import Image from 'components/Image';
import useIsMobile from 'hooks/useIsMobile';
import { Account } from 'model/IChat';
import React from 'react';

const CSS = require('./BookBlockDatePicker.module.scss');

const IMAGE_OPTIONS = {
  width: 24,
  height: 24,
  zoom: 0.8,
  crop: 'thumb',
  gravity: 'faces',
};

interface BookBlockDatePickerProps {
  selectedDate?: string;
  onDateChange: (date: string) => void;
  availableDates: { date: string; locals: string[] }[];
  preferredLocal?: Partial<Account>;
  showHighlights?: boolean;
  isLoading: boolean;
}

function BookBlockDatePicker({
  selectedDate,
  onDateChange,
  availableDates,
  preferredLocal,
  showHighlights,
  isLoading,
}: BookBlockDatePickerProps) {
  const isMobile = useIsMobile();
  return (
    <>
      <DatePicker
        selectedDate={selectedDate}
        onDateChange={onDateChange}
        availableDates={availableDates}
        withAvailability
        preferredLocal={showHighlights && preferredLocal}
        variant="jade"
        showTwoMonths={!isMobile}
        isLoading={isLoading}
      />
      {showHighlights && preferredLocal && (
        <div className={CSS.Legend}>
          <span className={CSS.DayLegend}>
            <Image
              src={preferredLocal.photo}
              width={IMAGE_OPTIONS.width}
              height={IMAGE_OPTIONS.height}
              options={IMAGE_OPTIONS}
              className={CSS.LocalImage}
            />
          </span>
          <span className={CSS.LegendText}>
            {preferredLocal.firstName} is available on these dates
          </span>
        </div>
      )}
    </>
  );
}

export default BookBlockDatePicker;
